import React from "react";
import { PrimaryButton } from "../Base/Button";
import { Box } from "@mui/material";
import { BasicButton } from "../Base/BasicButton";
const SkipButton = ({ form, disabled, skipHandler, displayVal = "" }) => {
  return (
    <Box
      className="skipButton_Th"
      sx={{
        position: "fixed",
        top: "92.5%",
        left: "50%",
        maxWidth: "425px",
        width: "calc(100%)",
        padding: "20px 16px",
        // backgroundColor: 'white',
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <BasicButton
          // text="Skip"
          text={displayVal ? displayVal : "Skip"}
          textColorA="rgb(13, 28, 110)"
          className="skipButtonBg_Th"
          borderColorA="#616FC6"
          variant="outlined"
          onClick={skipHandler}
        />

        <PrimaryButton
          form={form && form}
          type="submit"
          disabled={disabled && disabled}
          width="48%"
          mb="0"
          mt="0"
        />
      </Box>
    </Box>
  );
};

export default SkipButton;
